import type { Simulation } from "rujira.js";
import type { V2PrivateFeeQuote } from "./fees";

/** The normal transaction button carries the exact displayed fee quote through
 * to its existing Confirm action. This is a fee review, not a chain simulation. */
export type V2ReviewedSimulation = Simulation & {
  privateFeeQuote: V2PrivateFeeQuote;
};

export const reviewedPrivateSimulation = (
  privateFeeQuote: V2PrivateFeeQuote
): V2ReviewedSimulation => ({
  amount: 0n,
  decimals: 0,
  gas: 0n,
  symbol: "",
  privateFeeQuote,
});

export const privateFeeQuoteFromSimulation = (
  simulation: Simulation | undefined
): V2PrivateFeeQuote | undefined => {
  if (!simulation || !("privateFeeQuote" in simulation)) return undefined;
  const quote = simulation.privateFeeQuote as V2PrivateFeeQuote | undefined;
  if (
    !quote ||
    typeof quote.id !== "string" ||
    !Number.isFinite(quote.expiresAt)
  )
    return undefined;
  return quote;
};
